import { render } from "./CommunicationGroup.vue?vue&type=template&id=241cf906"
import script from "./CommunicationGroup.vue?vue&type=script&lang=js"
export * from "./CommunicationGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__